import { render, staticRenderFns } from "./qSidebar.vue?vue&type=template&id=6584d864&"
import script from "./qSidebar.vue?vue&type=script&lang=ts&"
export * from "./qSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports